import React from "react";
import MainSearchPanel from "./MainSearchPanel";

const Hero = ({
  initialText = "",
  onSubmit,
  onQueryChange,
  searchMode,
  onSearchModeChange,
}) => {
  return (
    <section
      className="gf-hero gf-hero--tool gf-hero--landing"
      aria-labelledby="gf-hero-title"
    >
      <div className="gf-hero__content">
        <h1 id="gf-hero-title" className="gf-hero__title gf-hero__title--landing">
          Find GitHub Developers &amp; Repositories Instantly
        </h1>
        <p className="gf-hero__sub gf-hero__sub--landing">
          Search developers or repositories with filters tuned for real-world discovery.
        </p>
        <MainSearchPanel
          variant="hero"
          initialText={initialText}
          onSubmit={onSubmit}
          onQueryChange={onQueryChange}
          searchMode={searchMode}
          onSearchModeChange={onSearchModeChange}
        />
      </div>
    </section>
  );
};

export default Hero;
